import React from "react";
import { useFormik } from "formik";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import {Checkbox} from 'primereact/checkbox';
import { classNames } from "primereact/utils";
import * as yup from "yup";
import { signup } from "../../services";
import { useDispatch } from "react-redux";
import { showSuccessMessage } from "../../redux/action";

const SignupComponent = (props) => {
  const dispatch = useDispatch();
  const validations = yup.object().shape({
    name: yup.string().required("name is required"),
    country: yup.string().required("country is required"),
    city: yup.string().required("city is required"),
    location: yup.string().required("location is required"),
    numOfMeters: yup
      .number()
      .integer("meters number must be a positive number")
      .positive("meters number must be a positive number")
      .required("meters number is required"),
    email: yup.string().email("email not valid").required("email is required"),
    password: yup.string().required("password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("comfirm password is required"),
      accept:yup.string().required("You need to agree to the terms and conditions.")
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      country: "",
      city: "",
      location: "",
      numOfMeters: "",
      email: "",
      password: "",
      confirmPassword: "",
      accept:"",
    },
    validationSchema: validations,
    onSubmit: (data) => {
      signup(data).then((response) =>{
        dispatch(showSuccessMessage("user added successfully "));
        setTimeout(() =>{
          dispatch(showSuccessMessage(""));
        },500);
        props.activeLoginTab();
      })
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  return (
    <form onSubmit={formik.handleSubmit} className="p-fluid row">
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="name"
          placeholder="Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("name") })}
        />
        {getFormErrorMessage("name")}
      </div>
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="email"
          placeholder="Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("email") })}
        />
        {getFormErrorMessage("email")}
      </div>
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="country"
          placeholder="Country"
          value={formik.values.country}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("country") })}
        />
        {getFormErrorMessage("country")}
      </div>
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="city"
          placeholder="City"
          value={formik.values.city}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("city") })}
        />
        {getFormErrorMessage("city")}
      </div>
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="location"
          placeholder="Location (google map link)"
          value={formik.values.location}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("location") })}
        />
        {getFormErrorMessage("location")}
      </div>
      <div className="field col-md-6 col-xs-12 mt-4 mb-3">
        <InputText
          name="numOfMeters"
          placeholder="Number of Meters"
          value={formik.values.numOfMeters}
          onChange={formik.handleChange}
          className={classNames({
            "p-invalid": isFormFieldValid("numOfMeters"),
          })}
        />
        {getFormErrorMessage("numOfMeters")}
      </div>

      <div className="field mb-3 mt-4 col-md-6 col-xs-12">
        <span>
          <Password
            id="password"
            name="password"
            feedback={false}
            value={formik.values.password}
            placeholder="Password"
            onChange={formik.handleChange}
            toggleMask
            className={classNames({
              "p-invalid": isFormFieldValid("password"),
            })}
          />
        </span>
        {getFormErrorMessage("password")}
      </div>
      <div className="field mb-3 mt-4 col-md-6 col-xs-12">
        <span>
          <Password
            name="confirmPassword"
            feedback={false}
            value={formik.values.confirmPassword}
            placeholder="Confirm Password"
            onChange={formik.handleChange}
            toggleMask
            className={classNames({
              "p-invalid": isFormFieldValid("confirmPassword"),
            })}
          />
        </span>
        {getFormErrorMessage("confirmPassword")}
      </div>

      <div className="field-checkbox">
        <Checkbox
          inputId="accept"
          name="accept"
          checked={formik.values.accept}
          onChange={formik.handleChange}
          className={classNames({ "p-invalid": isFormFieldValid("accept") })}
        />
        <label
          htmlFor="accept"
          className={classNames({ 'mx-2' :true,"p-error": isFormFieldValid("accept") })}
        >
          I agree to the terms and conditions *
        </label>
      </div>
      <Button type="submit" label="Submit" className="submit" />
    </form>
  );
};

export default SignupComponent;
